import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { toggleEditMode } from '../../../shared/utils';
import { CustomValidator } from '../../../shared/validation';
import { IAdresse } from '../../models/adresse';

@Component({
  selector: 'app-adresse',
  templateUrl: './adresse.component.html',
  styleUrls: ['./adresse.component.scss']
})
export class AdresseComponent implements OnInit, OnChanges {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  title: string;

  @Input()
  idprefix: string;

  @Input()
  required: boolean;

  @Input()
  showGroup = true;

  constructor() { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      strasse: new UntypedFormControl(''),
      hausnummer: new UntypedFormControl(''),
      stiege: new UntypedFormControl('', CustomValidator.addressPattern),
      stock: new UntypedFormControl('', CustomValidator.addressPattern),
      tuernummer: new UntypedFormControl('', CustomValidator.addressPattern),
      plz: new UntypedFormControl(''),
      ort: new UntypedFormControl('')
    });
  }

  ngOnInit(): void {
    const plzValidators = [Validators.pattern('^[0-9]{4}$')];
    const ortValidators = [Validators.pattern('^[^0-9]*$')];
    const hausnummerValidators = [CustomValidator.addressPattern];

    if (this.required === true) {
      this.strasse.setValidators([Validators.required]);
      plzValidators.push(Validators.required);
      ortValidators.push(Validators.required);
      hausnummerValidators.push(Validators.required);
    }

    this.plz.setValidators(plzValidators);
    this.ort.setValidators(ortValidators);
    this.hausnummer.setValidators(hausnummerValidators);
    this.formGroup.updateValueAndValidity();
    this.toggleEditMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showGroup && changes.showGroup.currentValue !== changes.showGroup.previousValue ) {
      this.toggleEditMode();
    }
  }

  get strasse() { return this.formGroup.get('strasse'); }
  get hausnummer() { return this.formGroup.get('hausnummer'); }
  get stiege() { return this.formGroup.get('stiege'); }
  get stock() { return this.formGroup.get('stock'); }
  get tuernummer() { return this.formGroup.get('tuernummer'); }
  get plz() { return this.formGroup.get('plz'); }
  get ort() { return this.formGroup.get('ort'); }

  toggleEditMode(): void {
    toggleEditMode(this.strasse, this.showGroup);
    toggleEditMode(this.hausnummer, this.showGroup);
    toggleEditMode(this.stiege, this.showGroup);
    toggleEditMode(this.stock, this.showGroup);
    toggleEditMode(this.tuernummer, this.showGroup);
    toggleEditMode(this.plz, this.showGroup);
    toggleEditMode(this.ort, this.showGroup);
  }

  setAdresse(adresse: IAdresse) {
    this.strasse.setValue(adresse.Strasse);
    this.hausnummer.setValue(adresse.Hausnummer);
    this.stiege.setValue(adresse.Stiege);
    this.stock.setValue(adresse.Stock);
    this.tuernummer.setValue(adresse.Tuernummer);
    this.plz.setValue(adresse.Plz);
    this.ort.setValue(adresse.Ort);
  }

  getAdresse(): IAdresse {
    return {
      Strasse: this.strasse.value,
      Hausnummer: this.hausnummer.value,
      Stiege: this.stiege.value,
      Stock: this.stock.value,
      Tuernummer: this.tuernummer.value,
      Plz: this.plz.value,
      Ort: this.ort.value
    };
  }
}
